import React, { useState } from 'react';
import './Testimonials.css';

const Testimonials = ({ language = 'de' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = {
    de: [
      {
        name: 'Sarah M.',
        location: 'Berlin, Deutschland',
        rating: 5,
        text: 'Meine Tochter liebt es absolut! Sie ist jetzt die Heldin ihrer eigenen Geschichten. Die KI-generierten Illustrationen sind wunderschön und die Geschichten sind perfekt für ihr Alter.',
        avatar: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=200&h=200&fit=crop&crop=faces'
      },
      {
        name: 'Michael K.',
        location: 'München, Deutschland',
        rating: 5,
        text: 'Als berufstätiger Vater ist StoryTales ein Lebensretter. In wenigen Minuten habe ich eine personalisierte Geschichte für meinen Sohn. Er wartet jeden Abend gespannt auf seine neue Geschichte!',
        avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop&crop=faces'
      },
      {
        name: 'Lisa & Thomas B.',
        location: 'Hamburg, Deutschland',
        rating: 5,
        text: 'Wir nutzen StoryTales für unsere zweisprachige Erziehung. Geschichten auf Deutsch und Englisch zu haben ist fantastisch. Unsere Kinder lernen spielerisch beide Sprachen.',
        avatar: 'https://images.unsplash.com/photo-1598676598606-d184bdb5c500?w=200&h=200&fit=crop&crop=faces'
      }
    ],
    en: [
      {
        name: 'Sarah M.',
        location: 'Berlin, Germany',
        rating: 5,
        text: 'My daughter absolutely loves it! She\'s now the hero of her own stories. The AI-generated illustrations are beautiful and the stories are perfectly suited for her age.',
        avatar: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?w=200&h=200&fit=crop&crop=faces'
      },
      {
        name: 'Michael K.',
        location: 'Munich, Germany',
        rating: 5,
        text: 'As a working dad, StoryTales is a lifesaver. In just a few minutes, I have a personalized story for my son. He eagerly awaits his new story every night!',
        avatar: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&h=200&fit=crop&crop=faces'
      },
      {
        name: 'Lisa & Thomas B.',
        location: 'Hamburg, Germany',
        rating: 5,
        text: 'We use StoryTales for our bilingual upbringing. Having stories in German and English is fantastic. Our kids are learning both languages playfully.',
        avatar: 'https://images.unsplash.com/photo-1598676598606-d184bdb5c500?w=200&h=200&fit=crop&crop=faces'
      }
    ]
  };

  const currentTestimonials = testimonials[language] || testimonials.en;

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % currentTestimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + currentTestimonials.length) % currentTestimonials.length);
  };

  const current = currentTestimonials[currentIndex];

  return (
    <div className="testimonials-section">
      <h2>{language === 'de' ? 'Was Eltern sagen' : 'What Parents Say'}</h2>
      <p className="testimonials-subtitle">
        {language === 'de' 
          ? 'Tausende von Familien vertrauen auf StoryTales'
          : 'Thousands of families trust StoryTales'}
      </p>

      <div className="testimonial-container">
        <button className="testimonial-nav prev" onClick={prevTestimonial} aria-label="Previous">
          ‹
        </button>

        <div className="testimonial-card">
          <img src={current.avatar} alt={current.name} className="testimonial-avatar" />
          <div className="testimonial-rating">
            {'★'.repeat(current.rating)}
          </div>
          <p className="testimonial-text">"{current.text}"</p>
          <div className="testimonial-author">
            <strong>{current.name}</strong>
            <span>{current.location}</span>
          </div>
        </div>

        <button className="testimonial-nav next" onClick={nextTestimonial} aria-label="Next">
          ›
        </button>
      </div>

      <div className="testimonial-dots">
        {currentTestimonials.map((_, index) => (
          <button
            key={index}
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
            aria-label={`Go to testimonial ${index + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
